<div
    class="min-h-screen w-full flex items-center justify-center p-4 bg-cover bg-center bg-no-repeat bg-[url('/Background.svg')]">

    <div class="bg-white w-full max-w-[500px] rounded-3xl shadow-lg p-10 md:p-12">

        <div class="flex items-center justify-center gap-3 mb-8">
            <img src="/logo.svg" alt="plandag logo" class="h-10" />
            <span class="text-4xl font-semibold tracking-tight text-[#00165A]">plandag</span>
        </div>

        <div *ngIf="isTokenVerfied === false">
            <div class="flex flex-col items-center justify-center text-center">
                <div
                    class="w-20 h-20 rounded-full border-2 border-red-100 bg-red-50 flex items-center justify-center mb-6">
                    <i class="pi pi-exclamation-circle !text-4xl text-red-500"></i>
                </div>

                <h2 class="text-3xl font-semibold text-slate-700 mb-3">Link Expired</h2>

                <p class="text-slate-500 mb-8 max-w-[320px]">
                    This password reset link is invalid or has expired. Please request a new one.
                </p>

                <div class="w-full">
                    <app-button label="Back to Login" routerLink="/login" severity="info"
                        customClass="w-full custom-dark-blue" size="large">
                    </app-button>
                </div>
            </div>
        </div>

        <div *ngIf="isTokenVerfied">
            <!-- Form Container -->
            <ng-container *ngIf="!isPasswordReset; else successTemplate">
                <div class="text-center mb-8">
                    <h1 class="text-3xl font-bold text-[#00165A] mb-2">Reset Password</h1>
                    <p class="text-sm text-slate-600">
                        Enter a new password to secure your account.
                    </p>
                </div>

                <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                    <div class="mb-4">
                        <app-password #passwordRef formControlName="password" label="New Password" class="password"
                            [showValidationHints]="true" labelCustomClass="block mb-1 font-medium text-gray-700"
                            inputCustomClass="border border-gray-300 rounded-md px-3 h-[42px] w-full"
                            [submitted]="submitted"></app-password>
                    </div>

                    <div class="mb-4">
                        <app-password #confirmPasswordRef formControlName="confirmPassword" label="Confirm Password"
                            class="password" labelCustomClass="block mb-1 font-medium text-gray-700"
                            inputCustomClass="border border-gray-300 rounded-md px-3 h-[42px] w-full"
                            [placeholder]="'Confirm your password'" [submitted]="submitted"></app-password>

                        <!-- <small
                            *ngIf="resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched"
                            class="block text-red-500 mt-1">
                            Passwords do not match
                        </small> -->
                    </div>

                    <div class="w-full">
                        <app-button label="Reset" type="submit" severity="info" customClass="w-full custom-dark-blue"
                            size="large" [loading]="loading">
                        </app-button>
                    </div>
                </form>
            </ng-container>

            <!-- Success/Confirmation Screen -->
            <ng-template #successTemplate>
                <div class="flex flex-col items-center justify-center text-center">
                    <div class="w-20 h-20 rounded-full border-2 border-green-600 flex items-center justify-center mb-6">
                        <i class="pi pi-check !text-4xl text-green-600"></i>
                    </div>

                    <h2 class="text-3xl font-semibold text-slate-700 mb-3">Password Reset</h2>

                    <p class="text-slate-500 mb-8 max-w-[320px]">
                        Your password has been successfully reset. click below to login
                    </p>

                    <div class="w-full">
                        <app-button label="Back to Login" routerLink="/login" severity="info"
                            customClass="w-full custom-dark-blue" size="large">
                        </app-button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>